import styled from 'styled-components';

const PathStyled = styled.path`
  fill: currentColor;
`;

/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @returns {React.ReactElement} The rendered component
 */
const CalendarIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="31px"
    height="31px"
    viewBox="0 0 200 200"
    baseProfile="tiny"
  >
    <PathStyled d="M139 172.8l34.7-36.1h-19.1c-8.6 0-15.6 7-15.6 15.6v20.5zm45.2-83v-43c0-8.6-7-15.6-15.6-15.6h-10.1V39c0 4.3-3.5 7.8-7.8 7.8s-7.8-3.5-7.8-7.8v-7.8h-35.5V39c0 4.3-3.5 7.8-7.8 7.8s-7.8-3.5-7.8-7.8v-7.8H56.7V39c0 4.3-3.5 7.8-7.8 7.8s-7.8-3.5-7.8-7.8v-7.8h-9.7c-8.6 0-15.6 7-15.6 15.6v121.9c0 8.6 7 15.6 15.6 15.6h92v-32c0-17.2 14-31.2 31.2-31.2H192c3.1 0 6 1.9 7.2 4.8 1.2 2.9.6 6.2-1.6 8.5l-60.8 63.3c-1.5 1.6-3.5 2.4-5.6 2.4H31.4c-17.2 0-31.2-14-31.2-31.2v-122c0-17.2 14-31.2 31.2-31.2h9.7V7.9c0-4.3 3.5-7.8 7.8-7.8s7.8 3.5 7.8 7.8v7.8h35.1V7.9c0-4.3 3.5-7.8 7.8-7.8s7.8 3.5 7.8 7.8v7.8h35.5V7.9c0-4.3 3.5-7.8 7.8-7.8s7.8 3.5 7.8 7.8v7.8h10.1c17.2 0 31.2 14 31.2 31.2v43c0 4.3-3.5 7.8-7.8 7.8s-7.8-3.5-7.8-7.9zm-67.4 18.4c-4.3 0-7.8 3.5-7.8 7.8s3.5 7.8 7.8 7.8 7.8-3.5 7.8-7.8-3.5-7.8-7.8-7.8zm-34 34c-4.3 0-7.8 3.5-7.8 7.8s3.5 7.8 7.8 7.8 7.8-3.5 7.8-7.8-3.4-7.8-7.8-7.8zm7.8-26.2c0-4.3-3.5-7.8-7.8-7.8S75 111.7 75 116s3.5 7.8 7.8 7.8c4.4 0 7.8-3.5 7.8-7.8zm0-34c0-4.3-3.5-7.8-7.8-7.8S75 77.7 75 82s3.5 7.8 7.8 7.8c4.4 0 7.8-3.5 7.8-7.8zm-41.7 60.2c-4.3 0-7.8 3.5-7.8 7.8s3.5 7.8 7.8 7.8 7.8-3.5 7.8-7.8-3.5-7.8-7.8-7.8zm7.8-26.2c0-4.3-3.5-7.8-7.8-7.8s-7.8 3.5-7.8 7.8 3.5 7.8 7.8 7.8 7.8-3.5 7.8-7.8zm94-41.8c-4.3 0-7.8 3.5-7.8 7.8s3.5 7.8 7.8 7.8 7.8-3.5 7.8-7.8-3.5-7.8-7.8-7.8zM124.6 82c0-4.3-3.5-7.8-7.8-7.8S109 77.7 109 82s3.5 7.8 7.8 7.8 7.8-3.5 7.8-7.8zm-67.9 0c0 4.3-3.5 7.8-7.8 7.8s-7.8-3.5-7.8-7.8 3.5-7.8 7.8-7.8 7.8 3.5 7.8 7.8z" />
  </svg>
);

export default CalendarIcon;
